import { PipeTransform, Pipe } from "@angular/core";

@Pipe({name: 'keys'})
export class EnumKeysPipe implements PipeTransform {
  transform(value) : Object {
    return Object.keys(value).filter(e => typeof value[e as any] === "number");
  }
}